module.exports = __webpack_public_path__ + "img/ancillary-resilience.8050dba0.png";